//  This mixin concentrate the common logic of product components
export const productMixin = {
  props: ['product', 'productData', 'loadingStatus']
}
